/**
 * 需求分析
 */

import ppt from '@/assets/images/achievement/achievement-ppt.png';
import pdf from '@/assets/images/achievement/achievement-pdf.png';
import word from '@/assets/images/achievement/achievement-word.png';
import excel from '@/assets/images/achievement/achievement-excel.png';
import defaultFile from '@/assets/images/achievement/default-file.png';
import {
  demandDisassemblyApi,
  demandDisassemblyV3Api,
  modifyKeywordsApi
} from '@/api/requirement';


// 需求分析首页
export const requirementIndexMixin = {
  data() {
    return {
      ppt,
      pdf,
      word,
      excel,
      defaultFile,
      userId: '',
      questionId: null,
      textarea: '', // 左侧 需求描述
      keyWordLoading: false, // 立即识别 loading

      uploadFile: null,
      fileType: null,

      // 左侧 手动输入、文件解析
      current: 'input', // input 手动输入 | file 文件解析
      textObj: {
        input: '',
        file: '',
      },

      // MarkdownIt配置
      md: new MarkdownIt({
        html: true, // 禁止HTML标签
        breaks: false, // 将 \n 转换为 <br>
        linkify: true, // 自动识别链接
        typographer: true, // 优化排版
      }),

      disassemblyStaus: '', // 需求拆解状态

      pollTimer: null,   // 轮询定时器
      isPolling: false,  // 是否正在轮询
      pollCount: 0,      // 轮询次数
      maxPollCount: 1000,  // 最大轮询次数限制（防止无限轮询）

      // 右侧
      keywordList: [], // 关键词
      updateLoading: false, // 更新关键词 loading
      submitLoading: false, // 生成报告 loading
      keywordValue: '', // 关键词文本，空格拼接

      isEdit: false,
      // 关键词标签
      keywordHeight: '',
      keywordTags: [], // 关键词数组，空格分割，tagName
      tagVisible: false,
      tagValue: '',
    };
  },
  created() {
    this.userId = localStorage.getItem('at_userId');
  },
  methods: {
    // 返回
    handleBack() {
      location.reload();
    },

    // 渲染markdown
    markdownItFn(val) {
      return DOMPurify.sanitize(this.md.render(val || ''));
    },

    // 选择文件
    handleFileChange(file) {
      // 初始化
      this.uploadFile = this.fileType = null;

      // 校验文件
      let size = 20; // 文件大小
      let isLimit = file.size / 1024 / 1024 < size;
      if (!isLimit) {
        this.$message.error(`上传的文件大小不能超过 ${size}MB!`);
        return false;
      }

      // 保存文件对象
      this.uploadFile = file.raw;

      // 文件类型
      let type = file.name?.split('.').pop()?.toLowerCase() || '';
      if (type.includes('doc')) {
        this.fileType = word;
      } else if (type.includes('xls')) {
        this.fileType = excel;
      } else if (type.includes('pdf')) {
        this.fileType = pdf;
      } else if (type.includes('ppt')) {
        this.fileType = ppt;
      } else {
        this.fileType = defaultFile;
      }
    },

    // 删除文件
    deleteFile() {
      this.questionId = null;
      this.disassemblyStaus = '';
      this.uploadFile = this.fileType = null;
    },

    // 立即识别 v1
    getDemandDisassembly() {
      if (!this.textarea) {
        this.$message.warning('请输入需求描述');
        return;
      }
      this.keyWordLoading = true;

      const formData = new FormData();
      formData.append('prompt', this.textarea);
      formData.append('user_id', this.userId);

      demandDisassemblyApi(formData).then(res => {
        this.questionId = res.question_id;
        this.keywordList = res.data;
        this.keywordValue = res.data[0].keyword;

        if (this.keywordValue && this.keywordValue?.length) {
          let splitList = this.keywordValue.split(' ');
          this.keywordTags = splitList.map(item => {
            return { tagName: item }
          })
        } else {
          this.keywordTags = [];
        }

        this.$nextTick(() => {
          let dom = this.$refs.descContent;
          // console.log(dom.clientHeight);
          this.keywordHeight = 382 - (dom.clientHeight + 85);
        })

        // 初始化 关键词编辑
        this.isEdit = false;
        this.tagVisible = false;
        this.tagValue = '';

        this.keyWordLoading = false;
      }).catch(() => {
        this.keyWordLoading = false;
        this.$message.error('服务器错误,请联系工作人员');
      })
    },

    // 立即识别 v3
    getDemandDisassembly_V3() {
      this.questionId = null;
      this.disassemblyStaus = '';
      if (!this.textarea && !this.uploadFile) {
        this.$message.warning('请输入需求描述或上传文件！');
        return;
      }
      this.keyWordLoading = true;

      // 支持 手动输入、上传文件
      let formData = new FormData();
      formData.append('user_id', this.userId);
      if (this.textarea) {
        formData.append('prompt', this.textarea);
      }
      if (this.uploadFile) {
        formData.append('document', this.uploadFile);
      }

      demandDisassemblyV3Api(formData).then(res => {
        if (res.success) {
          this.disassemblyStaus = 'SUCCESS';
          this.questionId = res.question_id;
          this.keywordList = res.data;
          this.keywordValue = res.data[0].keyword;

          if (this.keywordValue && this.keywordValue?.length) {
            // 赋值 手动输入、文件解析
            this.textObj.input = res.question || '';
            this.textObj.file = this.markdownItFn(res.file_content) || '';
            if (this.textObj.file && !this.textObj.input) {
              this.current = 'file';
            } else {
              this.current = 'input';
            }

            let splitList = this.keywordValue.split(' ');
            this.keywordTags = splitList.map(item => {
              return { tagName: item }
            })
          } else {
            this.keywordTags = [];
          }

          this.$nextTick(() => {
            let dom = this.$refs.descContent;
            this.keywordHeight = 382 - (dom.clientHeight + 85);
          })

          // 初始化 关键词编辑
          this.isEdit = false;
          this.tagVisible = false;
          this.tagValue = '';

          this.keyWordLoading = false;
        } else {
          this.disassemblyStaus = 'RUNNING';
        }
      }).catch(error => {
        this.disassemblyStaus = 'ERROR';
        this.keyWordLoading = false;
        // 付费弹窗
        if (error.response?.status === 429) {
          this.confirmPay();
          return false;
        }
        // 其他错误处理
        else {
          this.$message.error('服务器出错啦，请稍后重试');
        }
      })
    },

    // 是否购买 对话框
    confirmPay() {
      this.$confirm('您的访问次数已达上限，如需继续使用可购买次数，是否立即购买？', '提示', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '立即购买',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$refs.requirementPayment.open();
      }).catch(() => {
      });
    },

    // 开始轮询 检查需求拆解状态
    startPolling() {
      // 防止重复开启轮询
      if (this.isPolling) {
        return;
      }

      this.keyWordLoading = true;
      this.isPolling = true;
      this.pollCount = 0;

      // 立即执行
      this.checkStatus();

      // 设置1.5秒间隔的定时器
      this.pollTimer = setInterval(() => {
        if (this.pollCount >= this.maxPollCount) {
          // console.warn('达到最大轮询次数，停止轮询');
          this.stopPolling();
          return;
        }

        this.checkStatus();
      }, 1500);
    },

    // 停止轮询
    stopPolling() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer);
        this.pollTimer = null;
      }
      this.keyWordLoading = false;
      this.isPolling = false;
    },

    // 检查需求拆解状态
    async checkStatus() {
      try {
        this.pollCount++;
        const Api = () => {};
        const res = await Api(this.questionId);
        // console.log(res);

        // 失败
        if (!res.success) {
          this.disassemblyStaus = 'ERROR';
          this.stopPolling(); // 结束轮询
          this.$message.warning(res.message);
        }

        // 完成
        if (res.data && res.data?.length) {
          this.disassemblyStaus = 'SUCCESS';
          this.keywordList = res.data;
          this.keywordValue = res.data[0].keyword;

          if (this.keywordValue && this.keywordValue?.length) {
            // 赋值 手动输入、文件解析
            this.textObj.input = res.original_prompt || '';
            this.textObj.file = this.markdownItFn(res.parsed_content) || '';
            if (this.textObj.file && !this.textObj.input) {
              this.current = 'file';
            } else {
              this.current = 'input';
            }

            let splitList = this.keywordValue.split(' ');
            this.keywordTags = splitList.map(item => {
              return { tagName: item }
            })
          } else {
            this.keywordTags = [];
          }

          this.$nextTick(() => {
            let dom = this.$refs.descContent;
            // console.log(dom.clientHeight);
            this.keywordHeight = 382 - (dom.clientHeight + 85);
          })

          // 初始化 关键词编辑
          this.isEdit = false;
          this.tagVisible = false;
          this.tagValue = '';

          this.stopPolling(); // 结束轮询
          // this.$message.success(res.message);
        }

        // 处理中
        else {
          // 继续轮询
          this.disassemblyStaus = 'RUNNING';
          // this.$message.warning(res.message);
        }

      } catch (error) {
        this.disassemblyStaus = '';
        this.stopPolling(); // 结束轮询
        this.$message.error('拆解需求失败');
      }
    },

    // 点击修改
    handleEdit () {
      if (!this.isEdit) {
        this.isEdit = true;
      } else {
        if (this.tagVisible) {
          this.tagValue = '';
          this.tagVisible = false;
        }
        this.handleUpdateKeyword();
      }
    },

    // 点击保存 更新
    handleUpdateKeyword() {
      if (!this.keywordTags || !this.keywordTags.length) {
        this.$message.warning('关键词不能为空');
        return false;
      }

      this.updateLoading = true;
      let keywordStr = this.keywordTags.map(item => item.tagName).join(' ');
      let pa = {
        technicalItem: {
          keyword: keywordStr,
          tech_id: 0,
        },
        question_id: this.questionId,
      }
      modifyKeywordsApi(pa).then(res => {
        if (res.success) {
          this.keywordValue = this.keywordList[0].keyword = keywordStr;
          this.$message.success('关键词更新成功');
          this.updateLoading = false;
          this.isEdit = false;
        } else {
          this.$message.warning('关键词更新失败，请稍后重试');
          this.updateLoading = false;
        }
      }).finally(() => {
        this.updateLoading = false;
      })
    },

    // 删除
    handleTagClose(tag) {
      let index = this.keywordTags.indexOf(tag);
      if (index !== -1) {
        this.keywordTags.splice(index,1);
      }
    },

    // 显示输入框
    showInput() {
      this.tagVisible = true;
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    // 暂存
    handleTagConfirm() {
      if (!this.tagValue) {
        this.$message.warning('关键词不能为空');
        return false;
      }
      let tagValue = this.tagValue;
      if (tagValue) {
        this.keywordTags.push({ tagName: tagValue });
      }
      this.tagVisible = false;
      this.tagValue = '';
    },

    // 生成报告
    goDetail() {
      if (!this.questionId) {
        this.$message.warning('请输入您的需求并识别');
        return false;
      }
      if (!this.keywordValue || !this.keywordTags?.length) {
        this.$message.warning('关键词不能为空');
        return false;
      }

      let keywordStr = this.keywordTags.map(item => item.tagName).join(' ');
      if (this.keywordValue !== keywordStr) {
        // this.handleUpdateKeyword();
        this.$message.warning('检测到关键词有变更，请先保存关键词再生成报告');
        return false;
      }
      this.$router.push({
        name: this.$route.name === 'requirementAnalysisGuoJiao' ? 'requirementDetailsGuoJiao' : 'requirementDetails',
        query: { questionId: this.questionId }
      });
    },
  },
  // 组件销毁时清理定时器
  beforeDestroy() {
    this.stopPolling();
  },
}


import MarkdownIt from 'markdown-it';
import DOMPurify from 'dompurify'; // HTML 消毒库
import 'github-markdown-css';
import _ from 'lodash';
import { REQUEST_BASE_URL } from '@/api/baseAPi';
import { demandAnalysisDetailApi, getRecommendTechApi, demandPdfApi, requirementPdfStatusApi, getDisassemblyDetailApi } from '@/api/requirement';
import { splitResponseByModulesEnhanced } from '@/utils/splitResponse';

// 需求分析详情
export const requirementDetailsMixin = {
  data() {
    return {
      achievementData:{},
      achievementLoading:false,
      prompt: '',
      questionId: '',
      status: '', // 需求分析 status
      sideMenuFixed: false,
      loadingData: false,
      analysisData: '',
      menuCurrent: 1,
      requirementData: {},
      menuList: [
        {
          id: 1,
          label: '需求概述',
        },
        {
          id: 2,
          label: '关键技术指标',
        },
        {
          id: 3,
          label: '技术关键点及难点',
        },
        {
          id: 4,
          label: '技术可行性',
        },
        {
          id: 5,
          label: '创新选题分析',
        },
        {
          id: 6,
          label: '专家机构匹配',
        },
        {
          id: 7,
          label: '关键指标符合度对比',
        },
        {
          id: 8,
          label: '机构详细分析',
        },
        {
          id: 9,
          label: '专家详细分析',
        },
        {
          id: 10,
          label: '成果推荐',
        },
        {
          id: 11,
          label: '综合建议与总结',
        }
      ],
      correlationTitleList: ['专利','专家', '机构','论文', '项目'],
      activeCorrelation: '专利',
      // MarkdownIt配置
      md: new MarkdownIt({
        html: true, // 禁止原生HTML（提高安全性）
        breaks: false, // 禁止单换行转 <br>
        linkify: true, // 自动识别链接
        typographer: true // 优化排版
      }),

      rawContent: '', // 原始流数据
      isStreaming: false, // 是否正在接收流数据
      receivedChunks: 0, // 接收的数据块数量

      thinkLoading: false,
      reportLoading: false,

      thinkingContent: '', // 思考过程
      reporterContent: '', // 报告

      thinkingMd: '', // 思考过程 md
      reporterMd: '', // 报告 md

      pdfLoading: false,

      pollTimer: null,   // 轮询定时器
      isPolling: false,  // 是否正在轮询
      pollCount: 0,      // 轮询次数
      maxPollCount: 400,  // 最大轮询次数限制（防止无限轮询）

      textObj: {
        input: '',
        file: '',
      },
      disassemblyData: [],


      splitStr: [
        '<需求概述></需求概述>',
        '<关键技术指标></关键技术指标>',
        '<技术关键点及难点></技术关键点及难点>',
        '<技术可行性></技术可行性>',
        '<创新选题分析></创新选题分析>',
        '<专家机构匹配></专家机构匹配>',
        '<关键指标符合度对比></关键指标符合度对比>',
        '<机构详细分析></机构详细分析>',
        '<专家详细分析></专家详细分析>',
        '<成果推荐></成果推荐>',
        '<综合建议与总结></综合建议与总结>'
      ],
    };
  },
  created() {
    this.prompt = [{ 'technology': '人工智能', 'keyword': '人工智能' }];
    this.questionId = this.$route.query.questionId;
    this.userId = this.$store.state.id || localStorage.getItem('at_userId');
    this.token = this.$store.getters.getToken || localStorage.getItem('at_token');
    if (this.questionId && this.userId) {
      this.getRequirement();
      this.startPolling();
      this.getDisassembly(); // 我的指令
    }
  },
  methods: {
    splitResponseByModulesEnhanced,
    // 点击 我的指令
    handleOpen() {
      this.$refs.disassemblyDialog.open();
    },

    // 我的指令 需求拆解
    getDisassembly() {
      let pa = {
        user_id: this.userId,
        question_id: this.questionId,
      };
      getDisassemblyDetailApi(pa).then((res) => {
        this.textObj.input = res.disassembly_detail[0]?.question || '';
        this.textObj.file = this.markdownItFn(res.disassembly_detail[0]?.file_content) || '';
        this.disassemblyData = res.disassembly_detail[0]?.answer?.data || [];
      })
    },

    // 滚动到底部
    scrollToBottom() {
      this.$nextTick(() => {
        const container = this.$refs.requirementContainer;
        if (container) {
          container.scrollTop = container.scrollHeight;
        }
      });
    },

    // 新会话
    handleBack() {
      this.$router.push({ name: 'requirementAnalysis' });
    },

    // 渲染markdown
    markdownItFn(val) {
      return DOMPurify.sanitize(this.md.render(val || ''));
    },

    // 开始轮询 检查PDF状态
    startPolling() {
      // 防止重复开启轮询
      if (this.isPolling) {
        return;
      }

      this.isPolling = true;
      this.pollCount = 0;

      // 立即执行
      this.checkStatus();

      // 设置10秒间隔的定时器
      this.pollTimer = setInterval(() => {
        if (this.pollCount >= this.maxPollCount) {
          // console.warn('达到最大轮询次数，停止轮询');
          this.stopPolling();
          return;
        }

        this.checkStatus();
      }, 10000);
    },

    // 停止轮询
    stopPolling() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer);
        this.pollTimer = null;
      }
      this.isPolling = false;
    },

    // 检查PDF状态
    async checkStatus() {
      try {
        this.pollCount++;

        const response = await requirementPdfStatusApi(this.questionId)
        this.status = response.canDownload ? 'SUCCESS' : 'RUNNING'

        if (this.status === 'SUCCESS') {
          this.getAchievement();
          this.stopPolling();
        }

      } catch (error) {
        console.error('检查状态失败:', error);
      }
    },

    // 导出pdf
    async exportPdf() {
      if (!this.status || this.status !== 'SUCCESS') {
        this.$message.warning('需求分析还未生成完，请稍后再试');
        return false;
      }
      this.pdfLoading = true;

      try {
        let id = this.questionId;
        const res = await demandPdfApi(id);
        // console.log(res);

        if (res.code === 200) {
          if (res.message === '已有重复PDF，无需再次生成') {
            this.$message.success('报告已存在, 请到“文件管理”中查看');
          } else if (res.message === 'PDF生成成功') {
            this.$message.success('报告生成成功, 请到“文件管理”中查看');
          }
        } else {
          this.$message.error('报告生成失败，请刷新后再试');
        }

        this.pdfLoading = false;
      } catch (error) {
        this.pdfLoading = false;
        console.error('导出PDF失败:', error);
        throw error;
      } finally {
        this.pdfLoading = false;
      }
    },

    // 需求分析详情
    getRequirement() {
      this.loadingData = true;
      this.achievementLoading = true;
      let pa = {
        question_id: this.questionId,
        user_id: this.userId,
      };
      demandAnalysisDetailApi(pa).then(res => {
        // console.log(res.analysis_detail.reporter);
        if (res.code === 200 && res.analysis_detail) {
          // 思考过程
          this.thinkingContent = res.analysis_detail?.thinking || '';
          this.thinkingMd = this.markdownItFn(this.thinkingContent);
          // 需求分析
          let reportContent = res.analysis_detail?.reporter || '';
          let modules = this.splitResponseByModulesEnhanced(reportContent, this.splitStr);
          const rendered = {};
          for (const key in modules) {
            const content = modules[key];
            rendered[key] = this.markdownItFn(content);
          }
          this.requirementData = rendered;
          this.getAchievement();
          this.loadingData = false;
          // 折叠思考过程、手动更新菜单高亮
          this.$nextTick(() => {
            if (this.$refs.toggleRef2) {
              this.$refs.toggleRef2.toggle();
            }
            this.watchScroll();
          });
        } else {
          this.loadingData = false;
          this.startStream();
        }
      }).finally(() => {
        this.loadingData = false;
      })
    },

    // 接收流数据
    async startStream() {
      if (this.isStreaming) return;

      this.rawContent = '';
      this.thinkingContent = '';
      this.reporterContent = '';
      this.receivedChunks = 0;

      let pa = {
        question_id: this.questionId,
        user_id: this.userId,
      }
      const url = REQUEST_BASE_URL + (process.env.VUE_APP_NAME === 'guojiao' ? '/api-key' : '') + '/tech/demand_analysis';
      this.isStreaming = true;
      this.thinkLoading = true;

      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': process.env.VUE_APP_NAME === 'guojiao' ? this.token : 'Bearer ' + this.token,
          },
          body: JSON.stringify(pa),
        });

        if (!response.ok) throw new Error(`HTTP错误 ${response.status}`);

        // 创建流式读取器
        const reader = response.body.getReader();
        const decoder = new TextDecoder('utf-8');

        // 递归读取流数据
        const readChunk = async () => {
          const { done, value } = await reader.read();

          if (done) {
            this.processChunk(); // 处理最后剩余数据
            this.thinkLoading = false;
            this.reportLoading = false;
            this.isStreaming = false;
            return;
          }

          // 解码并处理数据块
          this.rawContent += decoder.decode(value, { stream: true });
          this.processChunk();

          // 滚动到底部
          this.$nextTick(() => {
            this.scrollToBottom();
          })

          // 继续读取下一个块
          await readChunk();
        };

        await readChunk();

      } catch (error) {
        this.$message.error(error.message);
        this.isStreaming = false;
        this.thinkLoading = false;
        this.reportLoading = false;
      }
    },

    // 处理流数据
    processChunk() {
      // 按换行符分割完整数据包
      const packets = this.rawContent.split('\n');
      this.rawContent = packets.pop() || ''; // 保留不完整数据

      packets.forEach((packet) => {
        if (!packet.trim()) return;

        try {
          const cleanData = packet.replace(/^data: /, '');
          const parsed = JSON.parse(cleanData); // 合法的JSON

          if (parsed.error) {
            this.$message.error(parsed.error);
            return false;
          }

          switch (parsed.type) {
            case 'thinking':
              // eslint-disable-next-line no-case-declarations
              const thinking = parsed.content.replace(/\\n/g, '\n'); // 处理JSON转义
              this.thinkingContent += thinking;
              break;

            case 'reporter':
              this.thinkLoading = false;
              this.reportLoading = true;
              // eslint-disable-next-line no-case-declarations
              const reporter = parsed.content.replace(/\\n/g, '\n'); // 处理JSON转义
              this.reporterContent += reporter;
              break;

            case 'done':
              this.thinkLoading = false;
              this.reportLoading = false;
              this.isStreaming = false;
              // eslint-disable-next-line no-case-declarations
              let modules = this.splitResponseByModulesEnhanced(this.reporterContent, this.splitStr);
              // 预渲染markdown
              // eslint-disable-next-line no-case-declarations
              const rendered = {};
              for (const key in modules) {
                const content = modules[key];
                rendered[key] = this.markdownItFn(content);
              }
              this.requirementData = rendered;
              this.getAchievement()
              // 折叠思考过程
              this.$nextTick(() => {
                if (this.$refs.toggleRef2) {
                  this.$refs.toggleRef2.toggle();
                }
              })
              // console.log('流式传输结束');
              break;

            case 'error':
              // eslint-disable-next-line no-case-declarations
              const errContent = parsed.content.replace(/\\n/g, '\n'); // 处理JSON转义
              console.log(errContent, 'errContent');
              break;

            case 'log':
              this.$message.warning('服务器异常，请刷新页面');
              break;
          }

          // 滚动dom
          this.$nextTick(() => {
            if (this.isStreaming) {
              // 滚动到底部
              this.scrollToBottom();
            } else {
              // 滚动到顶部
              let dom = this.$refs.requirementContainer;
              setTimeout(() => {
                dom && dom.scrollTo({ top: 0, behavior: 'smooth'});
              }, 800);
            }
          })

          // 更新计数器
          this.receivedChunks++

        } catch (e) {
          // console.warn('JSON解析错误:', e, '原始数据:', packet);
        }
      })
    },

    activeCo(item) {
      this.activeCorrelation = item;
      this.$nextTick(() => {
        let dom = this.$refs.scrollContainer;
        dom && dom.scrollTo({ top: 0 });
      })
    },

    // 监听滚动
    watchScroll() {
      let dom = this.$refs.requirementContainer;
      if (!dom) return false;

      const scrollY = dom.scrollTop;
      // 从后往前遍历，找到第一个 offsetTop <= scrollY 的 section（即当前可视区域顶部所在的 section）
      let currentId = 1; // 默认第一个
      for (let i = this.menuList.length - 1; i >= 0; i--) {
        const id = this.menuList[i].id;
        const el = document.getElementById(String(id));
        if (el) {
          // offsetTop 是相对于 offsetParent 的，但在 body 下通常就是文档坐标
          // 更稳妥的方式：使用 getBoundingClientRect + scrollY
          const rect = el.getBoundingClientRect();
          const top = rect.top + scrollY;

          // 判断：滚动位置是否已进入该 section（可加偏移避免临界抖动）
          if (scrollY >= top - 136) { // -100 是偏移量，让高亮提前触发，体验更顺滑， 36 是顶部导出pdf按钮高度
            currentId = id;
            break;
          }
        }
      }

      this.menuCurrent = currentId;
    },

    // 切换侧边栏
    changeMenu(event, id) {
      this.menuCurrent = id;
      event.preventDefault();
      const dom = document.getElementById(id);
      if (dom) {
        dom.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    },

    //获取相关文献
    getAchievement(){
      this.achievementLoading = true;
      getRecommendTechApi({pageNum:0,pageSize:5,question_id:this.questionId}).then(res => {
        this.achievementLoading = false;
        this.achievementData = res;
      }).catch(() => {
        this.achievementLoading = false;
      })
    },
  },
  // 组件销毁时清理定时器
  beforeDestroy() {
    this.stopPolling();
  },
  watch: {
    'thinkingContent': {
      handler: _.debounce( function(nv) {
        this.thinkingMd = this.markdownItFn(nv);
      }, 100),
      // immediate: true,
      deep: true,
    },
    'reporterContent': {
      handler: _.debounce( function(nv) {
        this.reporterMd = this.markdownItFn(nv);
        this.$nextTick(() => {
          nv && this.scrollToBottom();
        })
      }, 100),
      // immediate: true,
      deep: true,
    },
  }
}
